<template>
  <main class="customer_join main">
    <div class="join_inner">
      <div class="text_area">
        <h2>가입을 축하드려요!<br />어떻게 불러드리면 될까요?</h2>
        <p>설정된 닉네임은 마이페이지에서 변경 가능해요!</p>
      </div>
      <div class="input_txt">
        <div class="input">
          <input
            type="text"
            placeholder=""
            v-model="nickname"
            maxlength="10"
            @input="isNickname"
          />
          <p class="input_time">{{ nicknameLeng }}/10</p>
        </div>
      </div>
    </div>
    <div class="join_btn_area">
      <button :disabled="isDisabled" @click="joinStart()">시작하기</button>
    </div>
  </main>
</template>
<script>
import {
  sleep,
  nativeDeviceInfo,
  nativeLocation,
  sdk_logEvent,
  sdk_logEventKakao,
  isApp,
  checkMobile,
  // initLocation,
} from '@common/lib/common/utils';

import StorageFactory from '@common/lib/common/storage';
import AppAccessAuthorityModal from '@/front/customer/views/auth/modal/AppAccessAuthorityModal';
import { authMapActions, authTypes } from '@common/store/modules';
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import {
  mapActions as mapXeronoteActions,
  mapGetters as mapXeronoteGetters,
} from '@common/store/modules/xeronote';
import * as xeronoteTypes from '@common/store/modules/xeronote/types';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

export default {
  name: '',
  components: {},
  data() {
    return {
      nickname: '',
      nicknameLeng: 0,
      isDisabled: true,
      dl_id: '',
      isExDeal: false,
      dealId: 0,
      redir: '',
      isRedir: false,
    };
  },
  async created() {
    this.dl_id = localStorage.getItem('dl_id');

    console.log(this.dl_id);

    if (this.dl_id && !isApp()) {
      this.isExDeal = true;
      let dl_id_sp = this.dl_id.split('_');
      this.dealId = dl_id_sp[1];
    } else {
      this.isExDeal = false;
    }

    this.redir = localStorage.getItem('redir');

    if (this.redir && !isApp()) {
      this.isRedir = true;
    } else {
      this.isRedir = false;
    }

    await this.getNickname();
  },
  async mounted() {},
  computed: {
    ...userMapGetters({
      user: userTypes.USER,
    }),
    ...mapXeronoteGetters({
      nicknameList: xeronoteTypes.NICKNAME,
    }),
  },
  methods: {
    ...mobileMapActions([mobileTypes.MOBILE_DEAL_CHAT]),
    ...authMapActions([
      authTypes.REGISTER_MOBILE,
      authTypes.LOGIN,
      authTypes.SOCIAL_CHECK,
      authTypes.SOCIAL_REGISTER,
    ]),
    ...userMapActions([
      userTypes.FIND_USER_BY_MOBILE_NUMBER,
      userTypes.FETCH_ME,
      userTypes.SET_USER,
      userTypes.UPDATE_USER_TELECOM_AND_DEVICE,
      userTypes.USER_UPDATE_ME,
      userTypes.UPDATE_AREA_ME,
      userTypes.UPDATE_USER_DATA,
      userTypes.UPDATE_NICKNAME,
    ]),
    ...mapXeronoteActions([xeronoteTypes.FETCH_NICKNAME]),
    async getNickname() {
      await this[xeronoteTypes.FETCH_NICKNAME]();
      // console.log(this.nicknameList.content[0].nickname);

      this.nickname = this.nicknameList.content[0].nickname;

      this.nicknameLeng = this.nickname.length;
      if (this.nicknameLeng == 0) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    },
    isNickname() {
      if (this.nickname.trim() == '') {
        this.nickname = this.nickname.trim();
      }
      this.nicknameLeng = this.nickname.length;

      if (this.nicknameLeng == 0) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    },
    // 회원가입
    async joinStart() {
      // 가입방법 ( mobile, kakao, apple )
      const joinMethod = localStorage.getItem('join_method');

      // 휴대폰 번호
      const mobileNumber = localStorage.getItem('join_mobile');
      // 인증번호
      const authNumber = localStorage.getItem('join_authNumber');
      // 성별
      const gender = localStorage.getItem('join_gender');
      // 나이
      const age = localStorage.getItem('join_age');

      // 지역
      const join_region = localStorage.getItem('join_region');

      let region = '';
      if (join_region) {
        region = JSON.parse(join_region);
      } else {
        this.$router.push({
          name: 'Auth.JoinRegion',
        });
      }

      console.log(joinMethod);
      console.log(mobileNumber);
      console.log(region);
      console.log(age);
      console.log(gender);
      console.log(this.nickname);
      console.log(authNumber);

      let user_id = '';
      this.nickname = this.nickname.trim();

      if (joinMethod == 'mobile') {
        let joinParam = {
          mobileNumber: mobileNumber,
          code: authNumber,
        };

        if (isApp()) {
          joinParam.joinRoute = 'APP';
        } else {
          if (checkMobile()) {
            joinParam.joinRoute = 'MOBILE';
          } else {
            joinParam.joinRoute = 'PC';
          }
        }

        // 1. 휴대폰 등록
        this[authTypes.REGISTER_MOBILE](joinParam)
          .then(msg => {
            // this.login(mobileNumber, authNumber);
            let loginParam = {
              username: mobileNumber,
              password: authNumber,
              roles: 10,
            };
            // 2. 로그인
            this[authTypes.LOGIN](loginParam).then(() => {
              // 3. 회원정보 가져오기
              this[userTypes.FETCH_ME]().then(response => {
                user_id = response.id;
                const userParams = { nickname: this.nickname };
                // 4. 닉네임 업데이트
                this[userTypes.UPDATE_NICKNAME](userParams).then(() => {
                  // 5. 성별, 나이, 지역 저장
                  const payload = {
                    gender: gender,
                    ageRange: age,
                    areaInfo: region,
                  };
                  console.log(payload);

                  this[userTypes.UPDATE_USER_DATA](payload).then(() => {
                    this.getDevice();

                    sdk_logEvent('LOGIN_JOIN', {
                      user_id: user_id,
                      user_nickname: this.nickname,
                      login_method: joinMethod,
                    });

                    sdk_logEventKakao('LOGIN_JOIN_MOBILE');

                    if (this.isExDeal) {
                      // 채팅방으로 이동 처리
                      this.enterChatRoom(this.dealId);
                    } else {
                      if (this.isRedir) {
                        this.$router.push({ path: this.redir }).catch(err => {
                          this.$router.push({ name: 'Home' });
                        });
                      } else {
                        this.$router.push({ name: 'Home' });
                      }
                    }
                  });
                });
              });
            });
          })
          .catch(() => {
            console.log('register_error');
            this.$router.push({ name: 'Auth.Login' });
          });
      } else if (joinMethod == 'kakao') {
        const join_kakao_info = localStorage.getItem('join_kakao_info');

        let kakao_info = '';
        if (join_kakao_info) {
          kakao_info = JSON.parse(join_kakao_info);
        } else {
          this.$router.push({
            name: 'Auth.Login',
          });
        }

        console.log(kakao_info);

        const params = {
          providerId: kakao_info.providerId,
          providerUserId: kakao_info.providerUserId,
          email: kakao_info.email,
          gender: kakao_info.gender,
          ageRange: kakao_info.ageRange,
          mobileNumber: kakao_info.mobileNumber,
          nickname: this.nickname,
          areaId: region.areaId,
          codeType: region.codeType,
          joinRoute: '',
        };

        if (isApp()) {
          params.joinRoute = 'APP';
        } else {
          if (checkMobile()) {
            params.joinRoute = 'MOBILE';
          } else {
            params.joinRoute = 'PC';
          }
        }

        // 1. 소셜 등록
        this[authTypes.SOCIAL_REGISTER](params).then(res => {
          // 기존회원
          if (res.isUser) {
            // 그냥 로그인
          } else {
            // 기존 회원 아님 신규 회원 가입됨
            sdk_logEvent('LOGIN_JOIN', {
              user_id: res.userId,
              user_nickname: this.nickname,
              login_method: joinMethod,
            });

            sdk_logEventKakao('LOGIN_JOIN_KAKAO');
          }

          const passwordkey = '_KAKAO';
          const username = kakao_info.mobileNumber;
          const password = `${kakao_info.providerUserId}${kakao_info.mobileNumber}${passwordkey}`;

          this.login(username, password, 12);
        });
      } else if (joinMethod == 'apple') {
        const join_appleId = localStorage.getItem('join_appleId');

        const params = {
          providerId: 'APPLE',
          providerUserId: join_appleId,
          email: '',
          gender: gender,
          ageRange: age,
          mobileNumber: mobileNumber,
          nickname: this.nickname,
          areaId: region.areaId,
          codeType: region.codeType,
          joinRoute: '',
        };

        if (isApp()) {
          params.joinRoute = 'APP';
        } else {
          if (checkMobile()) {
            params.joinRoute = 'MOBILE';
          } else {
            params.joinRoute = 'PC';
          }
        }

        // 1. 소셜 등록
        this[authTypes.SOCIAL_REGISTER](params).then(res => {
          // 기존회원
          if (res.isUser) {
            // 그냥 로그인
          } else {
            // 기존 회원 아님 신규 회원 가입됨
            sdk_logEvent('LOGIN_JOIN', {
              user_id: res.userId,
              user_nickname: this.nickname,
              login_method: joinMethod,
            });
            sdk_logEventKakao('LOGIN_JOIN_APPLE');
          }

          const passwordkey = '_APPLE';
          const username = mobileNumber;
          const password = `${join_appleId}${mobileNumber}${passwordkey}`;

          this.login(username, password, 12);
        });
      }
    },
    async login(username, password, roles = 10) {
      // alert(1);
      let loginParam = {
        username: username,
        password: password,
        roles: roles,
      };
      console.log('loginParam :: {}', loginParam);

      await this[authTypes.LOGIN](loginParam).then(() => {
        this.getDevice();

        if (this.isExDeal) {
          // 채팅방으로 이동 처리
          this.enterChatRoom(this.dealId);
        } else {
          if (this.isRedir) {
            this.$router.push({ path: this.redir }).catch(err => {
              this.$router.push({ name: 'Home' });
            });
          } else {
            this.$router.push({ name: 'Home' });
          }
        }
      });
    },
    async getDevice() {
      nativeDeviceInfo();
      await sleep(800);
      const myDeviceName = window.$bridge.deviceModelName || '';
      const myTelecomName = window.$bridge.telecomName || '';

      if (myDeviceName != '' || myTelecomName != '') {
        let td_param = {
          id: this.user.id,
          deviceName: myDeviceName,
          deviceModelName: '',
          telecomName: myTelecomName,
        };

        console.log('td_paramvtd_paramtd_paramtd_param');
        console.log(td_param);

        this[userTypes.UPDATE_USER_TELECOM_AND_DEVICE](td_param);
      }
    },
    enterChatRoom(id) {
      const params = {
        id: id,
      };

      this[mobileTypes.MOBILE_DEAL_CHAT](params)
        .then(res => {
          console.log('resresresresresresres');
          console.log(res);

          this.$router.push({
            name: 'chat.room',
            params: {
              uuid: res,
            },
          });
        })
        .catch(e => {
          console.log('error');
        });
    },
  },
};
</script>
